import type { Version } from '../../../model/version/types';

export const SET_VERSIONS = 'state.actions.version.SET_VERSIONS' as const;

export type SetVersionsPayload = { versions: string[] };

export type SetVersionsAction = {
	type: typeof SET_VERSIONS;
	payload: SetVersionsPayload;
};

export const setVersions = (payload: SetVersionsPayload) => ({
	type: SET_VERSIONS,
	payload,
});

export const UPDATE_VERSION = 'state.actions.version.UPDATE_VERSION' as const;

export type UpdateVersionAction = {
	type: typeof UPDATE_VERSION;
	payload: {
		version: Version;
	};
};

export const updateVersion = (version: Version) => ({
	type: UPDATE_VERSION,
	payload: {
		version,
	},
});

export const REFETCH_VERSIONS = 'state.actions.version.REFETCH_VERSIONS';

export type RefetchVersionsAction = {
	type: typeof REFETCH_VERSIONS;
};

export const refetchVersions = (): RefetchVersionsAction => ({
	type: REFETCH_VERSIONS,
});

export type Action = SetVersionsAction | UpdateVersionAction | RefetchVersionsAction;
